import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useRef } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
// import PricingButton from "./PricingButton";
import FaqAccordion from "./FaqAccordian";
import "./PricingPage.css";
import { toast } from "react-toastify";
import emailjs from "@emailjs/browser";
import { RotatingLines } from "react-loader-spinner";

let featursList = [
  // {name: "Accounting Integrations", to: "/features/accounting-integration"},
  { name: "Unit File Management", to: "/unit-management" },
  { name: "E-consent Management", to: "/e-consent" },
  { name: "Budget Mail-Outs", to: "/online-payments" },
  { name: "Announcements", to: "/announcements" },
  { name: "Maintenance Requests", to: "/maintenance-requests" },
  { name: "Violations Tracking", to: "/violations-tracking" },
  { name: "Document Drive", to: "/document-drive" },
  { name: "Amenity Bookings", to: "/amenity-bookings" },
  { name: "Events Calendar", to: "/events-calendar" },
  { name: "Visitor Management", to: "/visitor-management" },
  { name: "Visitor Parking Permit", to: "/visitor-parking-permit" },
  // { name: "Bulletin Board", to: "/bulletin-board" },
  // { name: "Resident Directory", to: "/resident-directory" },
  // { name: "Resident Portal", to: "/resident-portal" },
  // {name: "Portfolio Management", to: "/portfolio-management"},
  // { name: "Online Payments", to: "/online-payments" },
  // { name: "Support", to: "" },
];

// const pricingPlans = {
//   "1 - 2 units": 10,
//   "3 - 5 units": 20,
//   "6 - 10 units": 30,
//   "11 - 20 units": 50,
//   "21 - 50 units": 100,
//   "51 - 100 units": 200,
//   "101 - 200 units": 400,
//   "201 - 500 units": 500,
//   "501 - 1000 units": 800,
//   "1000+ Units": "Call for price",
// };

const PricingCalculator = () => {
  const handleGoToFeaturePage = (link) => {
    if (link) {
      window.location.href = link;
    }
  };

  const form = useRef();

  // console.log(form);

  const [loader, setLoader] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [fieldErrors, setFieldErrors] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleSendBookingMails = (e) => {
    e.preventDefault();
    setLoader(true);

    // validations

    let errors = {};
    let vals = { ...formData };
    if (!vals.name) errors.name = "Name is required!";
    if (!vals.email) errors.email = "Email is required!";
    if (!vals.phone) errors.phone = "Phone is required!";
    setFieldErrors({ ...errors });

    if (Object.keys(errors).length > 0) {
      // console.log(errors);
      setLoader(false);
      toast.error("Please correct above errors!", { theme: "colored" });
      return;
    }

    // proceed
    let userName = formData.name;
    userName = userName.trim();
    let userEmail = formData.email;
    userEmail = userEmail.toLowerCase().trim();
    let userPhone = formData.phone;
    userPhone = userPhone.trim();
    let userMessage = formData.message;

    let systemHtmlBody = `<div>
      <h2 style="text-align: center">Quote Request</h2>
      <p>Dear Team,</p>
      <p>
        A new "Get a Quote" request has been submitted through the website form. 
        Please find the details below:
      </p>
      <p>Name : <b>${userName}</b></p>
      <p>Email : <b>${userEmail}</b></p>
      <p>Phone : <b>${userPhone}</b></p>

      <p>Message :</p>

      <blockquote>
        <b>
         ${userMessage}
        </b>
      </blockquote>
    </div>`;

    // let visitorHtmlBody = `<div>
    //   <h2 style="text-align: center">Demo Booking</h2>
    //   <p>Hy ${userName},</p>
    //   <p>
    //     Thank you for your interest in Condozak. We've received your request to
    //     book a demo of our application.
    //   </p>
    //   <p>Our team will get in touch with you shortly to schedule the demo.</p>
    // </div>`;

    // send mails

    // to system
    sendMailTemplate(
      // "CondozakTM Application Demo Booking Request",
      "New Quote Request Received",
      "info@condozak.ca",
      // "tor.ws02.truzak@gmail.com",
      "Peter Agency",
      systemHtmlBody,
      userName,
      userEmail
    );

    // to visitor
    // sendMailTemplate(
    //   "Demo Booking Request Received",
    //   userEmail,
    //   "CondozakTM",
    //   visitorHtmlBody,
    //   userName,
    //   userEmail
    // );

    //cleanup
    setFormData({ name: "", email: "", phone: "", message: "" });

    setFieldErrors({ name: "", email: "", phone: "", message: "" });

    setLoader(false);
  };

  const sendMailTemplate = (
    subject = "subject",
    receiver_email = "",
    from_name = "",
    html_body = ``,
    name = "",
    email = ""
    // phone = "",
    // message = ""
  ) => {
    // Create form element
    const form = document.createElement("form");
    form.method = "POST";
    // form.action = "https://example.com/submit"; // optional if not used
    // form.target = "_blank"; // optional

    // Add form fields
    const addField = (name, value) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      form.appendChild(input);
    };

    addField("subject", subject);
    addField("receiver_email", receiver_email);
    addField("from_name", from_name);
    addField("html_body", html_body);
    addField("name", name);
    addField("email", email);
    // addField("phone", phone);
    // addField("message", message);

    // Append form to the DOM (required by emailjs)
    document.body.appendChild(form);

    // Send the form using emailjs
    emailjs
      .sendForm(
        "service_xpqo9vl",
        "template_sjwzooo",
        form,
        "Y8ATuGO2CeFmtgEeA"
      )
      .then(
        (result) => {
          console.log(result);
          toast.success(
            "Thank you! Your quote request has been submitted. \n Our team will contact you shortly.",
            { theme: "colored" }
          );

          // If you still want to submit the form elsewhere, do it here
          // form.submit(); // uncomment if needed

          // Clean up
          document.body.removeChild(form);
        },
        (error) => {
          console.error(error);
          toast.error("Something went wrong!", { theme: "colored" });
          document.body.removeChild(form); // still clean up
        }
      );
  };

  const handleFieldChange = (e) => {
    let vals = { ...formData };
    vals[e.target.name] = e.target.value;
    setFormData({ ...vals });
  };

  return (
    <Container className="py-1 p-4 shadow rounded bg-white">
      <Row className="g-3">
        <Col
          lg={12}
          className="d-flex flex-column flex-md-row justify-content-center align-items-center"
          // style={{ minHeight: "100px" }}
        >
          {/* <h5 className="me-3 text-center text-md-start fs-1 fs-md-1">
            Let us customize the perfect plan for your community.
          </h5> */}
          <br/>
          <br/>
          <br/>
        </Col>

        <Col
          className="d-flex  justify-content-center border-end"
          style={{ minHeight: "300px" }}
          lg={6}
        >
          <div style={{ width: "70%" }}>
            <p className="lead text-center text-md-start pb-0">Get a Quote</p>
            <form ref={form} onSubmit={handleSendBookingMails}>
              {[
                { name: "Name", key: "name" },
                { name: "Email Address", key: "email" },
                { name: "Phone #", key: "phone" },
                { name: "Message", key: "message" },
              ].map((v, i) => (
                <Form.Group key={i + 3214} className="mb-3">
                  <Form.Label htmlFor={v.key}>{v.name}</Form.Label>
                  <Form.Control
                    name={v.key}
                    onChange={handleFieldChange}
                    value={formData[v.key]}
                    as={v.key === "message" ? "textarea" : "input"}
                    rows={2}
                  />
                  <div>
                    <p className="text-danger fs--1 ">{fieldErrors[v.key]}</p>
                  </div>
                </Form.Group>
              ))}
              <div style={{ marginTop: "30px" }}></div>
              <div className="text-center">
                <Button
                  variant="primary"
                  type="submit"
                  size="lg"
                  className="rounded-pill"
                >
                  {loader ? <RotatingLines width="30" strokeColor="white"/> : "Get a Quote"}
                </Button>
              </div>
            </form>
          </div>
        </Col>

        <Col
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ minHeight: "300px" }}
          lg={6}
        >
          <p className="lead text-center text-md-start pb-0">
            Core Plan Features
          </p>
          <ul
            className="list-unstyled text-start mx-auto"
            style={{ maxWidth: "300px" }}
          >
            {featursList.map((v) => (
              <li
                key={v.name}
                onClick={() => handleGoToFeaturePage(v.to)}
                className="pb-2"
              >
                <FontAwesomeIcon icon="check" className="me-2 text-success" />{" "}
                {v.name}
              </li>
            ))}
          </ul>
          <Button
            variant="primary"
            size="lg"
            className="rounded-pill"
            onClick={() =>
              window.open("https://condozak.app/company/register", "_blank")
            }
          >
            Start your free trial
          </Button>
        </Col>

        <Col lg={12} className="">
          <br />
          <br />
          <br />
          <br />
          <FaqAccordion />
        </Col>
      </Row>
    </Container>
  );
};

export default PricingCalculator;

// ✅
